<template lang="pug">
  div
    div(v-if="datagraf && datagraf.lines && datagraf.lines.length")
      ods-dataviz-bar(
        :data="datagraf"
        :title-tag="titleTag"
        :title="title"
        :renderType="renderType"
        :height="height"
        :width="width"
        :boundary-gap="boundaryGap"
        :animation="animation"
        :bar-gap="barGap"
        :y-axis-name="datagraf.yAxisName"
        :y-axis-name-padding="YAxisNamePadding"
        :show-y-labels="showYLabels"
        :show-y-axis-line="showYAxisLine"
        :y-axis-label-suffix="yAxisLabelSuffix"
        :show-y-split-line="showYSplitLine"
        :interval="interval"
        :x-axis-name="datagraf.xAxisName"
        :show-x-labels="showXLabels"
        :show-x-axis-line="showXAxisLine"
        :x-axis-label-suffix="xAxisLabelSuffix"
        :show-x-split-line="showXSplitLine"
        :rotateLabel="rotateLabel"
        :left-space="leftSpace"
        :right-space="rightSpace"
        :show-tooltip="showTooltip"
        :tooltip-suffix-value="tooltipSuffixValue"
        :trigger="trigger"
        :stack="stack"
        :smooth-lines="smoothLines"
        :colors="colors"
        :legend="true"
        :zoom="zoom"
        :showXFilterZoom="showXFilterZoom"
        :showYFilterZoom="showYFilterZoom")
        template(slot="toolbox")
          ods-button(type="text" :icon="stack ? 'ods-icon-chart-bar' : 'ods-icon-chart-line'" v-on:click.native="changeStack")
    ods-module(v-else :header="title" shadow="never").loaddiv
      h3 {{ $t('noResults') }}
</template>

<script>
export default {
  name: 'SingleLineChart',
  props: {
    datagraf: {
      required: true
    },
    title: {
      required: true
    },
    colors: {
      required: true
    },
    tag: {
      required: true
    },
    linkTo: {
      required: true
    }
  },
  data () {
    return {
      titleTag: 'h3',
      renderType: 'svg',
      height: '30vh',
      width: '100%',
      boundaryGap: false,
      animation: true,
      barGap: 0,
      showTooltip: true,
      tooltipSuffixValue: '',
      tooltipPosition: '',
      YAxisName: '',
      YAxisNamePadding: 1,
      showYLabels: true,
      showYAxisLine: true,
      yAxisLabelSuffix: '',
      showYSplitLine: true,
      interval: 1,
      XAxisName: '',
      showXLabels: true,
      showXAxisLine: true,
      xAxisLabelSuffix: '',
      showXSplitLine: true,
      rotateLabel: false,
      leftSpace: 30,
      rightSpace: 0,
      trigger: 'item',
      stack: true,
      smoothLines: false,
      showLegend: true,
      legendPosition: 'bottom',
      legendAlign: 'right',
      zoom: false,
      showXFilterZoom: true,
      showYFilterZoom: true
    }
  },
  methods: {
    changeStack () {
      this.stack = !this.stack
    }
  }
}
</script>

<style lang="scss">
</style>
